<template>
    <b-col :cols="expandGraphs ? '12' : '3'" class="d-flex justify-content-between">
        <b-card class="mb-0 five9-graphs-cards expand-card" :class="expandGraphs ? 'expand-graph' : '' " style="min-height:200px" v-b-visible="mountedAction">
            <template v-slot:header>
                <span class="h6"><i class="mr-1" :class="main_icon"></i> {{ title }}</span>
            </template>

            <div v-if="data == null" style="min-height: 200px; padding-top:80px;">
                <loading-spinner :busy="data == null"></loading-spinner>
            </div>
            <div v-else class="h-100">
                <b-row class="h-100">
                    <b-col>
                        <b-table-simple small borderless hover>
                            <b-thead head-variant="light">
                                <b-th>Source</b-th>
                                <b-th class="text-right text-black-50">New</b-th>
                                <b-th class="text-right text-black-50">VIP</b-th>
                                <b-th class="text-right">Total</b-th>
                            </b-thead>
                            <b-tbody>
                         <template v-for="(item, i) in data" >
                             <b-tr :key="i" class="data">
                                <b-td class="data__title">{{ item.full_description | ucFirst }}:</b-td>
                                <b-td class="text-right font-weight-normal text-black-50">{{ item.total - item.vip }}</b-td>
                                <b-td class="text-right font-weight-normal text-black-50">{{ item.vip }}</b-td>
                                <b-td class="text-right">{{ item.total }}</b-td>
                             </b-tr>
                        </template>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                    <b-col cols="12" class="h-100 mt-2">
                        <ChartPie :data="chartData" :options="chartData.options" style="height: 100%"></ChartPie>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </b-col>
</template>

<script>
    import LoadingSpinner from '../../../components/LoadingSpinner';
    import ChartPie from '../graphs/ChartPie.vue';
    export default {
        components: {LoadingSpinner, ChartPie},
        name: 'Conversion1',
        props: {
            dataDisplay: {type:String,default: null},
            main_icon: {type:String,default:''},
            name: String,
            load_url: String,
            icons: Array,
            time_wait: { type: Number, default: 10000000 },
            title: String,
            bgColor: {type: String, default: 'light'},
        },
        data(){
            return {
                expandGraphs: false,
                vipLeads: null,
                ncLeads: null,
                totalLeads: null,
                chartData: {

                    datasets: [
                        {
                            data: [],
                            backgroundColor: ['#20a8d869', '#ffc40087'],
                            borderColor: ['#20a8d8', '#ffc400'],
                            borderWidth: 2
                        }
                    ],
                    labels: ['New', 'VIP'],

                    options: null,
                },
                hasAction: false,
                data: null,
            };
        },
        beforeDestroy(){
            clearInterval(this.interaval);
        },
        methods:{
            callAPI: function () {
                var _this = this;
                this.$http.post(this.load_url)
                        .then(response => {
                    console.log('data',  response.data.data);
                    _this.data = response.data.data;
                    _this.createChartData();
                });
            },
            expandGraph() {
                let expandCard = document.querySelectorAll('.expand-card');
                expandCard.forEach(function (card) {
                    card.classList.remove('expand-graph');
                });
                this.expandGraphs = !this.expandGraphs;
            },


            mountedAction(viewable) {
                if(!this.hasAction && viewable) {
                    this.callAPI();
                    this.interaval = setInterval(
                            this.callAPI,
                            this.time_wait
                    );
                    this.hasAction = true;
                }
            },
            createChartData() {
                let that = this;
                this.data.forEach( function (d) {
                    if(d.full_description === 'ppc - google' ) {
                        d.full_description = 'PPC - Google';
                    }
                    if(d.full_description === 'ppc - bing' ) {
                        d.full_description = 'PPC - Bing';

                    }
                    if(d.full_description === 'my-account' ) {
                        d.full_description = 'My Account';

                    }
                    if(d.full_description === 'all' ) {
                        that.chartData.datasets[0].data[0] = (d.total - d.vip);
                        that.chartData.datasets[0].data[1] = d.vip;
                    }
                });
            },
        },
    };

</script>


<style scoped>
    .merge-card {
        flex: 1;
        margin:0 1.5%;
    }

    .data {
        flex: 1;
        border-bottom: 1px solid #f4f4f4;
        margin-bottom: 2px
    }
    .data__title {
        font-weight: 400;
    }
    .data__num {
        float: right;
    }

    .display_on_top {
        z-index: 1000;
    }

    .card {
        flex: 1;
        /*margin: 0 8px;*/
        transition: .3s ease-in-out;
    }

    .card.expand-graph {
        flex: 5 !important;
    }
    .font-uppercase {
        text-transform: uppercase;
    }

</style>
